const BriefcaseIcon = ({ color = '#155DFC', width = '20px', height = '20px' }) => {
	return (
		<svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M13.3327 16.668V3.33464C13.3327 2.89261 13.1571 2.46868 12.8445 2.15612C12.532 1.84356 12.108 1.66797 11.666 1.66797H8.33268C7.89065 1.66797 7.46673 1.84356 7.15417 2.15612C6.84161 2.46868 6.66602 2.89261 6.66602 3.33464V16.668"
				stroke={color}
				strokeWidth="1.66667"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.666 5H3.33268C2.41221 5 1.66602 5.74619 1.66602 6.66667V15C1.66602 15.9205 2.41221 16.6667 3.33268 16.6667H16.666C17.5865 16.6667 18.3327 15.9205 18.3327 15V6.66667C18.3327 5.74619 17.5865 5 16.666 5Z"
				stroke={color}
				strokeWidth="1.66667"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default BriefcaseIcon;
